import { environment } from '../environments/environment';

export const appConfig = {
  baseApiUrl: environment.baseApiUrl,
  API_REGISTER_BUSINESS_ACCOUNT:
    environment.baseApiUrl + '/api/webmaster/accounts',
  FS_BUSINESS_ACCOUNT_PATH: '/data',
  FS_BUSINESS_USER_PATH: '/data/users',
};
